import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/fees-tradesy';

export default function Example() {
  return (
    <>
      <Head>
        <title>What You Need To Know About Tradesy Fees</title>
        <meta
          name='description'
          content='In this article, we’ll discuss what you need to know about navigating your way with Tradesy fees and just what is Tradesy’s fee structure all about.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/fees-tradesy' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/fees-tradesy' />
        <meta property='og:title' content='What You Need To Know About Tradesy Fees' />
        <meta
          property='og:description'
          content='In this article, we’ll discuss what you need to know about navigating your way with Tradesy fees and just what is Tradesy’s fee structure all about.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Tradesy' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
